import React, { createContext, useState, useContext } from 'react';
import { events } from '../data/events';

const EventContext = createContext();

export const useEvent = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEvent must be used within EventProvider');
  }
  return context;
};

export const EventProvider = ({ children }) => {
  const [selectedEvent, setSelectedEvent] = useState(events[0]);

  return (
    <EventContext.Provider value={{ selectedEvent, setSelectedEvent, events }}>
      {children}
    </EventContext.Provider>
  );
};

